import {Component, Input} from '@angular/core';
import {Product} from "@kion/data-models";

@Component({
  selector: 'kion-delivery-time',
  templateUrl: './delivery-time.component.html',
  styleUrls: ['./delivery-time.component.scss']
})
export class DeliveryTimeComponent {

  @Input() product: Product;

  deliveryTimeDaysText = 'delivery.time.information.days.text';
  deliveryTimeWeeksText = 'delivery.time.information.weeks.text';


}
